export default import.meta.ROLLDOWN_FILE_URL_sWvBmcF$Ke2NHFi9EikapQ